import { PayloadAction } from "@reduxjs/toolkit";

import { MyFleetState } from "../../types";

export const setSelectCar = (
  state: MyFleetState,
  action: PayloadAction<MyFleetState["selectedCar"]>
) => {
  state.selectedCar = action.payload;
};
